import 'leaflet';
import 'hammerjs';
import 'showdown';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {
  RouterModule,
  PreloadAllModules
} from '@angular/router';

import {AppComponent} from './components/app/app.component';
import {MapComponent} from './components/map/map.component';
import {SpotListComponent} from './components/spot-list/spot-list.component';
import {SpotDetailsComponent} from './components/spot-details/spot-details.component';

import {SafePipe} from './pipes/safe.pipe';

import {MapService} from './services/map.service';
import {GuideService} from './services/guide.service';
import {BackendService} from './services/backend.service';
import {WindowService} from './services/window.service';

import {ROUTES} from './routes';
import {CmsComponent} from './components/cms/cms.component';
import {
  MatChipsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatListModule, MatSidenavModule,
  MatToolbarModule
} from '@angular/material';

@NgModule({
  exports: [
    MatDialogModule, MatChipsModule, MatListModule, MatSidenavModule, MatToolbarModule, MatFormFieldModule, MatInputModule
  ]
})
export class GuidrMaterialModule {
}


@NgModule({
  declarations: [
    SafePipe,
    AppComponent,
    MapComponent,
    SpotListComponent,
    SpotDetailsComponent,
    CmsComponent,
  ],
  entryComponents: [SpotDetailsComponent],
  imports: [BrowserAnimationsModule, HttpModule, FormsModule,
    GuidrMaterialModule, BrowserModule, RouterModule.forRoot(ROUTES, {
      useHash: true,
      preloadingStrategy: PreloadAllModules
    })],
  providers: [
    GuideService,
    MapService,
    BackendService,
    {provide: WindowService, useValue: window}],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/app.module.ts